import Vue from "vue";
import Vuex from "vuex";

import loadData from "./loadData";
import profile from "./profile";
import dashboard from "./dashboard";
import role_template from "./role_template";
import role_assigment from "./role_assignment";
import role_management from "./role_management";
import users from "./users";
import dms_portal from "./dms_portal"

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		loadData,
		profile,
		dashboard,
		role_template,
		role_assigment,
		role_management,
		users,
		dms_portal
	},
});
